import usePusher from 'hooks/use-pusher';
import { useEffect } from 'react';
import { PusherConfig } from 'shared/constants';
import { PusherPreAuthEvent } from '../types';

type UsePreAuthPusherProps = {
  channelName: string | null;
  onSubscribe: () => void;
  onUnsubscribe: () => void;
  onEvent: (event: PusherPreAuthEvent) => void;
};

export const usePreAuthPusherSubscription = ({
  channelName,
  onSubscribe,
  onUnsubscribe,
  onEvent,
}: UsePreAuthPusherProps): void => {
  const pusher = usePusher();

  useEffect(() => {
    if (channelName) {
      onSubscribe();
      const preAuthChannel = pusher.subscribe(PusherConfig.AeroSyncPreAuth.CHANNEL(channelName));
      preAuthChannel.bind(PusherConfig.AeroSyncPreAuth.EVENTS.PRE_AUTH_STATUS_CHANGE, onEvent);

      return () => {
        onUnsubscribe();
        preAuthChannel.unbind(PusherConfig.AeroSyncPreAuth.EVENTS.PRE_AUTH_STATUS_CHANGE, onEvent);
        pusher.unsubscribe(PusherConfig.AeroSyncPreAuth.CHANNEL(channelName));
      };
    }

    return undefined;
  }, [channelName, onEvent, onSubscribe, onUnsubscribe, pusher]);
};
